import { FormControl, Input, InputAdornment } from '@mui/material';
import { IconName, MemreIcon } from 'components/core';

export default function MemreEditableHeading({ text, onChange, width = '25ch' }) {
  return (
    <FormControl variant="standard" sx={{ width }}>
      <Input
        value={text}
        sx={{ fontSize: '1.2rem', fontWeight: 700 }}
        onChange={onChange}
        endAdornment={
          <InputAdornment position="end">
            <MemreIcon iconName={IconName.edit} fontSize="1.1rem" />
          </InputAdornment>
        }
      />
    </FormControl>
  );
}
